<template>
  <v-container class="single-chart" grid-list-md text-xs-center>

    <!-- line chart -->
    <v-layout row wrap>
      <v-flex v-for="i in 2" :key="`6${i}`" sm6 xs12>
        <v-card dark color="secondary">
          <v-card-text class="px-0">
           <chartjs-line :fill="myLineChart.myboolean" :backgroundcolor="myLineChart.mybackgroundcolor" :bordercolor="myLineChart.mybordercolor"></chartjs-line>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- pie chart -->
    <v-layout row wrap>
      <v-flex v-for="i in 2" :key="`6${i}`" sm6 xs12>
        <v-card dark color="secondary">
          <v-card-text class="px-0">
           <chartjs-doughnut :labels="myPieChart.labels" :datasets="myPieChart.datasets" :option="myPieChart.option" :width="myPieChart.width" :heigth="myPieChart.height"></chartjs-doughnut>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- bar chart -->
    <v-layout row wrap>
      <v-flex v-for="i in 2" :key="`6${i}`" sm6 xs12>
        <v-card dark color="secondary">
          <v-card-text class="px-0">
           <chartjs-bar :labels="myBarchart.mylabels" :datasets="myBarchart.mydatasets"></chartjs-bar>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- polar chart -->
    <v-layout row wrap>
      <v-flex v-for="i in 2" :key="`6${i}`" sm6 xs12>
        <v-card dark color="secondary">
          <v-card-text class="px-0">
           <chartjs-polar-area :labels="myPolarChart.mylabels"  :datasets="myPolarChart.mydatasets"></chartjs-polar-area>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>


<script>
export default {
  name: "single-chart",
  data: function() {
    return {
      myLineChart : {
        myboolean : true,
        mybackgroundcolor : 'rgba(76,175,80,0.1)',
        mybordercolor : '#00c853'
      },
      myPieChart : {
        labels: ["Apple", "Banana", "Orange"],
        width : 400,
        height : 400,
        datasets: [
          {
            data: [25, 35, 40],
            backgroundColor: ["#eb1b33", "#eb1", "orange"]
          }
        ],
        option:{
          title: {
            display: true,
            position: 'bottom',
            text: 'Color'
          }
        }
      },
      myBarchart : {
        mylabels: ["January", "February", "March", "April", "May", "June", "July"],
        mydatasets:[
          {
            label: "My First dataset",
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            data: [65, 59, 80, 81, 56, 55, 40],
          },
          {
            label: "My Second dataset",
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1,
            data: [20, 50, 20, 41, 26, 85, 20],
          }
        ]
      },
      myPolarChart : {
        mylabels: ["Red", "Green", "Yellow", "Grey", "Blue"],
        mydatasets:[
          {
            data: [11, 16, 7, 3, 14],
            backgroundColor: [
                "#FF6384",
                "#4BC0C0",
                "#FFCE56",
                "#E7E9ED",
                "#36A2EB"
            ],
            label: 'My dataset' // for legend
          }
        ]
      }
    }
  }
}
</script>
